import React from 'react'
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import logo from './assets/logo.png'
import './style/newUserSetup.css'

import Typography from '@material-ui/core/Typography';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { makeStyles } from '@material-ui/core/styles';
import clsx from "clsx";

// set step icon style
const stepIconStyles = makeStyles({
  root: {
    backgroundColor: "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 30,
    height: 30,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
  },
  active: {
    backgroundColor: "#0A8B71",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
  completed: {
    backgroundColor: "#367386",
  }
});

function stepIcon(props) {
  const classes = stepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: 1,
    2: 2,
    3: 3
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}
  function getSteps() {
    return ['Get Phishy Extension', 'Check Extension', 'Use Phishy System'];
  }
  
  function extension()
  {
    return (
      <Container className="stepContent">
        <br />
        <Typography align="left"><b><u>INSTALL EXTENSION</u></b></Typography>
        <Typography align="left" className="content">Install our google chrome extension to use our services</Typography>
       
        <br />
        <Button className="btnGetChromeExtension" target="_blank" href="https://chrome.google.com/webstore/detail/cloudphish-anti-phishing/fcahokjdmffdhglnlhgbceafccfdfjkd">
            Get Chrome Extension
        </Button>
      </Container>
    );
  }

  function checkExtension()
  {
    return (
      <Container className="stepContent">
        <br />
        <Typography align="left"><b><u>CHECK EXTENSION STATUS</u></b></Typography>
        <Typography align="left" className="content">After the extension has been installed, open or refresh your Gmail page to ensure the extension is starting up or active.</Typography>
      </Container>
    );
  }

  function getStarted()
  {
    return (
      <Container className="stepContent">
        <br />
        <Typography align="left"><b><u>SETUP COMPLETED</u></b></Typography>
        <Typography align="left" className="content">You're ready to use our service by receiving securely authenticated emails!</Typography>
        
        <br />
        <Button className="btnGoToDashboard" href="/dashboard">
            Go To Dashboard
        </Button>
      </Container>
    );
  }
  
  function getStepContent(stepIndex, classes) {
    switch (stepIndex) {
      case 0:
        return extension(classes);
      case 1:
        return checkExtension();
      case 2:
        return getStarted(classes);
      default:
        return 'Unknown stepIndex';
    }
  }

    const UserSetup = () => {
        const [activeStep, setActiveStep] = React.useState(0);
        const steps = getSteps();

        const handleNext = () => {
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
        };

        const handleBack = () => {
          setActiveStep((prevActiveStep) => prevActiveStep - 1);
        };

        return (
            <>
            <div className="setUpContainer">
              <div className="setUpSectionContent">
                <br />
                <img src={logo} className="App-logo" alt="logo" />
                <h1> Setting Up </h1>

                <div className="setupContent">
                  <Stepper alternativeLabel activeStep={activeStep}>
                    {steps.map(label => (
                      <Step key={label}>
                        <StepLabel StepIconComponent={stepIcon}>{label}</StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                  <div>
                      <div className="stepContainer">
                          <Typography className="instructions">{getStepContent(activeStep)}</Typography>
                      </div>
                      <div className="btnSection">
                        <Button
                          disabled={activeStep === 0}
                          onClick={handleBack}
                          className="btnBack"
                        >
                          <h4>Back</h4>
                        </Button>
                        <Button className="btnNext" onClick={handleNext} disabled={activeStep === 2}>
                        <h4>Next</h4>
                        </Button>
                      </div>
                  </div>
                </div>
                </div>
            </div>
        </>
        )
    }
   
export default UserSetup;
